export default __webpack_public_path__ + "static/media/s.330ab86a.mp4";